<template v-slot:prepend>
  <div v-if="isNavigationDrawerOpen">
    <div style="position: absolute; top: 1px; right: 1px">
      <v-btn :color="theme.navDrawer.tabsColor" @click="$store.commit('toggleNavigationDrawer')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-list :color="theme.navDrawer.headerBg" dark tile class="header pl-4 pr-0 pb-2 pr-10">
      <v-list-item two-line>
        <profile-picture-avatar :employee="employee" :initials="initials" :photoUrl="photoUrl"></profile-picture-avatar>
        <v-list-item-content tile @click.stop="$store.commit('hideNavigationDrawer')" class="pl-7">
          <v-list-item-title class="headline">{{ user.firstName }} {{ user.lastName }}</v-list-item-title>
          <v-list-item-subtitle v-if="employeeNr"> {{ $t('employeeNr') }} {{ employeeNr }}</v-list-item-subtitle>
          <v-list-item-subtitle v-if="features.profileShowEmail"> {{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="isConnected">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click.stop="isLogoutDialogOpen = true" class="pt-4">
                <v-icon>mdi-logout</v-icon>
              </v-btn>
            </template>

            <span>{{ $t('logout') }}</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <logout-dialog
      :title="$t('logout.title')"
      :text="$t('logout.confirmMsg')"
      v-model="isLogoutDialogOpen"
      @onClose="isLogoutDialogOpen = false"
    ></logout-dialog>
  </div>
</template>

<script>
import configs from '@/common/config';
import utils from '@/common/utils';
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import LogoutDialog from './LogoutDialog';
import ProfilePictureAvatar from '@/components/navdrawer/ProfilePictureAvatar.vue';
import employeeService from '@/modules/employee/employeeService';
import networkUtils from "@/common/networkUtils";
import config from "@/common/config";

export default {
  mixins: [common, configMixin],
  components: {
    LogoutDialog,
    ProfilePictureAvatar,
  },
  props: {
    headerHeight: {
      type: Number,
    },
  },
  created() {
    this.configs = configs;
  },
  mounted() {
    this.checkIfIsOnline();
  },
  data() {
    return {
      isLogoutDialogOpen: false,
      isOnline: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      isConnected: (state) => state.isConnected,
    }),
    ...mapState('employee', ['personItemByEmployeeNr', 'photoByEmployeeId']),

    appVersion() {return config.appVersion},

    isNavigationDrawerOpen() {
      return this.$store.state.isNavigationDrawerOpen;
    },
    employeeNr() {
      return this.user.employeeNr;
    },
    employee() {
      return this.personItemByEmployeeNr[this.employeeNr];
    },
    initials() {
      let { firstName, lastName } = this.user;
      if (firstName && lastName) {
        return (firstName.substring(0, 1) + lastName.substring(0, 1)).toUpperCase();
      }
      return '';
    },
    photoUrl() {
      if (this.employee) {
        let fileName = employeeService.getPhotoFilename(this.photoByEmployeeId, this.employee);
        let fileUrl;
        if (fileName) {
          fileUrl = this.moduleFileUrl('employee', fileName);
        }
        return fileUrl;
      }
      return undefined;
    },
  },
  methods: {
    clearCaches() {
      document.dispatchEvent(new CustomEvent('clearCaches', { detail: {} }));
    },
    checkIfIsOnline() {
      networkUtils.isOnline({ commit: this.$store.commit }); //set isConnected state
    },
  },
  watch: {
    isNavigationDrawerOpen(newValue, oldValue) {
      if (newValue === true) {
        this.checkIfIsOnline();
      }
    },
  },
};
</script>
<style scoped>
.header {
  border-radius: 0;
}
</style>
